import { useContext } from 'react';

import GoogleAnalyticsContext from './context';

/**
 * Provides whole GoogleAnalyticsContext for advanced use, mostly useful for sending pageview events not-related to
 * component mount, the usePageview or useAnalyticsEvent are otherwise preferred.
 */
const useGoogleAnalytics = () => useContext(GoogleAnalyticsContext);

export default useGoogleAnalytics;
